import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { PulseFormProps } from "../../types/pulse.types";
import { useUpdatePulse } from "../../api/pulse.queries";
import { Spinner } from "@/components/ui/spinner";

export default function PulseForm({
  postData,
  snapshot,
  // onEdit,
  onDelete,
  onRefresh,
  isLoading,
  isDeletePending,
  onUpdate,
}: PulseFormProps) {
  const updatePulseMutation = useUpdatePulse();
  const hasChanges = snapshot?.has_changes;

  return (
    <div className="flex w-full flex-row items-end gap-5">
      <div className="flex w-full flex-col gap-1">
        <Label
          htmlFor="pulse-name"
          className="text-sm font-bold text-neutral-800"
        >
          Channel/Post URL
        </Label>
        <Input
          id="pulse-name"
          type="text"
          variant="filled"
          placeholder="Enter channel or post URL"
          value={postData?.data?.article_url || ""}
          required
          className="w-full truncate"
          disabled
        />
      </div>

      <div className="flex flex-row gap-2.5">
        <Button
          variant="outline"
          className="h-[45px] w-[45px]"
          onClick={onRefresh}
          icon
          disabled={isLoading}
        >
          {isLoading ? (
            <div className="flex h-full items-center justify-center">
              <Spinner size="sm" className="" />
            </div>
          ) : (
            <i className="ri-refresh-line text-[16px] font-light"></i>
          )}
        </Button>
        <Button
          variant="outline"
          className="h-[45px] w-fit"
          onClick={onUpdate}
          icon
          disabled={updatePulseMutation.isPending || !hasChanges}
        >
          Sync
        </Button>
        {/* <Button
          variant="outline"
          className="h-[45px] w-[45px]"
          onClick={onEdit}
          icon
        >
          <i className="ri-edit-line text-[16px] font-normal text-muted"></i>
        </Button> */}
        <Button
          variant="destructive"
          className="h-[45px] w-[45px] bg-red-100 hover:bg-red-100/80"
          onClick={onDelete}
          icon
          disabled={isDeletePending}
        >
          {isDeletePending ? (
            <div className="flex h-full items-center justify-center text-white">
              <Spinner size="sm" className="stroke-white!" />
            </div>
          ) : (
            <i className="ri-delete-bin-line text-[16px] font-normal text-[#B91C1C]"></i>
          )}
        </Button>
      </div>
    </div>
  );
}
